/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Field_MemoInputs */

const en_po_field_memo = /** @type {(inputs: Po_Field_MemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memo`)
};

/**
* | output |
* | --- |
* | "Memo" |
*
* @param {Po_Field_MemoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_field_memo = /** @type {((inputs?: Po_Field_MemoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Field_MemoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_field_memo(inputs)
});